<template>
  <span
      ref="activator"
      class="tooltip-activator"
      @mouseenter="onEnter"
      @mouseleave="onLeave"
  >
    <slot/>

    <!-- Slot oculto apenas para renderizar o conteúdo -->
    <span ref="content" class="tooltip-hidden">
      <slot name="content"/>
    </span>
  </span>
</template>

<script>
export default {
    name: 'MolensTooltip',
    props: {
        posicao: {
            type: String,
            default: 'top', // top | bottom | left | right
        },
        offset: {
            type: Number,
            default: 8,
        },
        maxWidth: {
            type: String,
            default: null, // ex: '300px'
        },
        height: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            tooltipEl: null,
        }
    },
    methods: {
        onEnter() {
            this.createTooltip()
        },
        onLeave() {
            this.removeTooltip()
        },
        createTooltip() {
            if (this.tooltipEl) return

            const el = document.createElement('div')
            el.className = `tooltip-box ${this.posicao}`

            // Conteúdo seguro
            if (this.$refs.content) {
                el.innerHTML = `
          <div class="tooltip-content">
            ${this.$refs.content.innerHTML}
          </div>
          <span class="tooltip-arrow"></span>
        `
            }

            // Dimensões
            if (this.maxWidth) {
                el.style.maxWidth = this.maxWidth
            }

            if (this.height) {
                el.style.height = this.height
                el.style.overflow = 'auto'
            }

            document.body.appendChild(el)
            this.tooltipEl = el

            this.positionTooltip()
        },
        positionTooltip() {
            this.$nextTick(() => {
                if (!this.tooltipEl) return

                const activator = this.$refs.activator.getBoundingClientRect()
                const tooltip = this.tooltipEl.getBoundingClientRect()

                let top = 0
                let left = 0

                switch (this.posicao) {
                    case 'bottom':
                        top = activator.bottom + this.offset
                        left = activator.left + (activator.width - tooltip.width) / 2
                        break

                    case 'left':
                        top = activator.top + (activator.height - tooltip.height) / 2
                        left = activator.left - tooltip.width - this.offset
                        break

                    case 'right':
                        top = activator.top + (activator.height - tooltip.height) / 2
                        left = activator.right + this.offset
                        break

                    default:
                        top = activator.top - tooltip.height - this.offset
                        left = activator.left + (activator.width - tooltip.width) / 2
                }

                this.tooltipEl.style.top = `${top}px`
                this.tooltipEl.style.left = `${left}px`
            })
        },
        removeTooltip() {
            if (this.tooltipEl) {
                document.body.removeChild(this.tooltipEl)
                this.tooltipEl = null
            }
        },
    },
    beforeDestroy() {
        this.removeTooltip()
    },
}
</script>

<style lang="stylus">
.tooltip-hidden
  display none

.tooltip-box
  position fixed
  background #fff
  color #333
  padding 10px 14px
  border-radius 6px
  font-size 13px
  line-height 1.4
  box-shadow 0 4px 12px rgba(0, 0, 0, .15)
  z-index 9999
  pointer-events none

  white-space normal
  word-break break-word
  overflow-wrap break-word

.tooltip-content
  position relative
  z-index 2

/* 🔺 Arrow base */
.tooltip-arrow
  position absolute
  width 0
  height 0
  z-index 1

/* 🔺 Arrow por posição */
.tooltip-box.top .tooltip-arrow
  bottom -6px
  left 50%
  transform translateX(-50%)
  border-left 6px solid transparent
  border-right 6px solid transparent
  border-top 6px solid #fff

.tooltip-box.bottom .tooltip-arrow
  top -6px
  left 50%
  transform translateX(-50%)
  border-left 6px solid transparent
  border-right 6px solid transparent
  border-bottom 6px solid #fff

.tooltip-box.left .tooltip-arrow
  right -6px
  top 50%
  transform translateY(-50%)
  border-top 6px solid transparent
  border-bottom 6px solid transparent
  border-left 6px solid #fff

.tooltip-box.right .tooltip-arrow
  left -6px
  top 50%
  transform translateY(-50%)
  border-top 6px solid transparent
  border-bottom 6px solid transparent
  border-right 6px solid #fff
</style>
